import React, { useContext } from 'react';
import { CodeInputModal } from './CodeInputModal';
import { EINModalContainer } from './EINModalContainer';
import { NationalAccountContext } from '../../../../../contexts';
import { shared } from '../../../../../constants/NationalAccount';
import { Modal } from '../commons';

export const EnrollModals = (): JSX.Element => {
  const { validResponseState } = useContext<any>(NationalAccountContext);
  return (
    <Modal title={shared.title}>
      {validResponseState?.enrollState ? (
        <CodeInputModal />
      ) : (
        <EINModalContainer />
      )}
    </Modal>
  );
};
